import {Component, OnInit, ViewChild} from '@angular/core';
import {
    ColumnFilter,
    DataTableColumnData, DatatableComponent,
    DataTableConfig,
    DataTableDataSource, DataTableObservableCompletionListener,
    DataTableObservableDataSource, DataTableObservableErrorListener,
    DataTableObservableRefresher, TableAction, HelpMessage
} from '@cas-hub/acabim-common-client';
import {LtmsService} from '../../../_services/ltms.service';
import {MaintenanceType} from '../../../_models/ltms.model';
import {map} from 'rxjs/operators';

@Component({
    selector: 'acabim-admin-maintenance-types',
    templateUrl: './maintenance-types.component.html',
    styleUrls: ['./maintenance-types.component.scss']
})
export class MaintenanceTypesComponent implements OnInit {
    public dataSources: DataTableDataSource<any>[] = [];
    showAddModal = false;
    modalTitle = '';
    helpMessage: HelpMessage = {
        message: 'Assets Maintenance Types are applicable to any project'
    };
    @ViewChild('dataTable') public dataTable?: DatatableComponent;

    constructor(private readonly maintenanceService: LtmsService) {
    }

    ngOnInit(): void {
        this.dataSources.push(new MaintenanceTypeDS(this.dataRefresher(), undefined, undefined, action => {
        }));
    }

    toggleStatus($event: boolean) {
        if ($event) {
            if (this.dataSources[0].detailData) {
                this.modalTitle = 'Edit Maintenance Type';
            } else {
                this.modalTitle = 'Add Maintenance Type';
            }
        } else {
            this.dataSources[0].detailData = undefined;
        }
        this.showAddModal = $event;
    }

    private dataRefresher(): DataTableObservableRefresher<MaintenanceType> {
        return () => this.maintenanceService.getTypes().pipe(map(data => {
            let typesArray: MaintenanceType[] = [];
            data.forEach(category => {
                category.types.map(type => type.category = category.category);
                typesArray = typesArray.concat(category.types);
            });
            return typesArray;
        }));
    }

    updateModalStatus($event: boolean) {
        this.toggleStatus(false);
        if ($event) {
            this.dataTable?.requestImmediateDataRefresh();
        }
    }
}

export class MaintenanceTypeDS<T extends MaintenanceType> extends DataTableObservableDataSource<T> {

    readonly columnData: DataTableColumnData[] =
        [{displayName: 'Id', objectPropertyName: 'id', colWidth: '5rem', textAlign: 'center'},
            {displayName: 'Name', objectPropertyName: 'name', colWidth: '20rem', textAlign: 'left'},
            {displayName: 'Description', objectPropertyName: 'description', textAlign: 'left'},
            {displayName: 'Category', objectPropertyName: 'category', colWidth: '10rem'},

        ];
    config: DataTableConfig;
    columnFilters: ColumnFilter[] = [];
    actions: TableAction[] = [];

    onDataExpanded(value: MaintenanceType): void {
    }

    constructor(readonly dataRefresher: DataTableObservableRefresher<T>,
                readonly observableErrorListener?: DataTableObservableErrorListener,
                readonly observableCompleteListener?: DataTableObservableCompletionListener,
                readonly actionListener?: (action: TableAction) => void) {
        super(() => this.dataRefresher(),
            undefined, undefined);

        this.config = {
            tableHeading: '',
            isSearchEnabled: false,
            searchPlaceHolder: '',
            emptyMessage: 'No account found',
            globalFilterFields: [],
            hasCheckbox: false,
            hasDetailsButton: true,
            isLazyLoadingEnabled: false,
            isPaginationEnabled: false,
            hasFilters: false,
            isExportEnabled: false,
            hasActions: false
        };
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }

    onDataFiltered(): void {
    }
}
